import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseFormInputField from '../../../../../../shared/components/base-input-form-field/base-form-input-field';
import { BasicInfoComponentProps } from '../../types/basic-info-component.props';

export const CampaignNameInput: FunctionComponent<BasicInfoComponentProps> = (
  props: PropsWithChildren<BasicInfoComponentProps>
) => {
  const { values, errors, touched, handleChange, handleBlur } = props;

  return (
    <FormControl data-testid="campaign-name-input-form-control">
      <BaseFormInputField
        id="name"
        label="Campaign name"
        name="name"
        onBlur={handleBlur}
        onChange={handleChange}
        error={!!errors.name && touched.name}
        helperText={!!errors.name && touched.name && errors.name}
        value={values?.name ?? ''}
        InputLabelProps={{ required: true }}
      />
    </FormControl>
  );
};
